import React, { useEffect, useRef } from "react";
import Aboutmain2 from "./Aboutmain2.jpeg";
import Navbar from "./Navbar";
import BackgroundImage from "./pexels-pixabay-534228.jpg";
const Why = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("shutter-effect");
        } else {
          entry.target.classList.remove("shutter-effect");
        }
      });
    };

    const createObserver = () => {
      const threshold = window.innerWidth < 768 ? 0.1 : 0.25;
      const observer = new IntersectionObserver(observerCallback, {
        threshold,
      });
      if (aboutRef.current) {
        observer.observe(aboutRef.current);
      }
      return observer;
    };

    const observer = createObserver();

    const handleResize = () => {
      observer.disconnect();
      createObserver();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <Navbar isHome={false} />
      <section
        ref={aboutRef}
        className="about-f py-3 py-md-5"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="container">
          <div className="row gy-3 gy-md-4 gy-lg-0 align-items-lg-center">
            <div className="col-12 col-lg-12">
              <div className="row justify-content-xl-center">
                <div className="col-12 col-xl-12">
                  <h1 className="mb-3 text-white">
                   Why 
                    <span className="text-danger">
                      <span style={{ textTransform: "uppercase" }}> P</span>
                      roperty92.pk
                    </span>
                     ?
                  </h1>
                  <p
                    className=" para mb-3 mb-xl-5"
                    style={{ textAlign: "justify",wordSpacing:"1px" }}
                  >
                    Property92.pk has specialized in Real Estate Industry by
                    making Sophisticated Systems &amp; Procedures for the
                    Management, Promotion &amp; Development of Real Estate
                    Projects (Housing, Commercial &amp; Industrial) in Pakistan.
                  </p>
                  <p
                    className=" para mb-3 mb-xl-5"
                    style={{textAlign:"justify",wordSpacing:"5px"}}
                  >
                    An un-matched services provider entity with Professional
                    &amp; Experienced Team capable to Plan, Launch, Execute and
                    Deliver the Projects on large scale that makes it a Premier
                    &amp; Leading Real Estate Company in Pakistan with the
                    widest network of sale.
                  </p>
                  <p
                    className=" para mb-3 mb-xl-5"
                    style={{textAlign:"justify",wordSpacing:"2px"}}
                  >
                    Property92.pk offers{" "}
                    <strong>
                      “Turn Key Solutions in the Real Estate Industry”
                    </strong>
                    What majorly differentiates us from our peers is the key
                    feature set of our core values:
                  </p>

                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0 text-warning">Honesty</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                       fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0 text-warning">Integrity</p>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <div className="me-3 text-primary">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        fill="blue"
                        class="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                    </div>
                    <div>
                      <p className="para m-0 text-warning">Delivery</p>
                    </div>
                  </div>
                </div>
              </div>
            </div><div className="col-12 col-lg-12 about-main">
              <img
                className="img-fluid rounded"
                loading="lazy"
                src={Aboutmain2}
                alt="About-2"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Why;
